"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find-index");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.number.constructor");

var _slicedToArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));

require("core-js/modules/es6.string.iterator");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.split");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _moment = _interopRequireDefault(require("moment"));

var _request = require("@/services/request/request.service");

var _helper = require("@/mixins/helper/helper");

var _logger = require("@/mixins/logger/logger");

var _loading = require("@/mixins/loading/loading");

var _permission = require("@/mixins/permission/permission");

var _numberCount = _interopRequireDefault(require("@/components/number-count/number-count.vue"));

var _miniGanttChart = _interopRequireDefault(require("@/components/mini-gantt-chart/mini-gantt-chart.vue"));

var _mapWorld = _interopRequireDefault(require("@/components/map-world/map-world.vue"));

var _mainDashboard = require("./main-dashboard.constants");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDMainDashboardComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDMainDashboardComponent, _Mixins);

  var _super = _createSuper(LMDMainDashboardComponent);

  function LMDMainDashboardComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDMainDashboardComponent);
    _this = _super.apply(this, arguments);
    _this.requestParameters = {};
    _this.locations = {};
    _this.dashboardData = {};
    _this.routingData = {};
    _this.summaryData = {};
    _this.selectedValues = [];
    _this.selectedLatlng = [];
    _this.week = null;
    _this.dates = [];
    _this.ganttDOI = 0;
    _this.ganttDate = null;
    return _this;
  }

  (0, _createClass2.default)(LMDMainDashboardComponent, [{
    key: "$planDate",
    get: function get() {
      return this.$store.getters['lastMileDelivery/planDate'];
    },
    set: function set(newVal) {
      this.$setPlanDate(newVal);
    }
  }, {
    key: "hasAssemblyMinutes",
    get: function get() {
      var hasAssemblyMinute = false;
      var default12 = this.helper.isNotEmpty(this.$userSetting['default12']) ? this.$userSetting['default12'].split('|') : [];

      if (default12.length >= 1 && this.helper.isInArray('capacity3', default12)) {
        hasAssemblyMinute = true;
      }

      return hasAssemblyMinute;
    }
  }, {
    key: "beforeCreate",
    value: function beforeCreate() {
      if (!this.request) {
        this.request = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
      }
    }
  }, {
    key: "created",
    value: function created() {
      this.loading = true;
      this.dashboardData = this.helper.cloneDeep(_mainDashboard.DEFAULT_DASHBOARD_DATA); // this.routingData = this.helper.cloneDeep(DEFAULT_ROUTING_DATA);

      this.$setDashboardVehicles([]);

      if (!this.requestLegacy) {
        this.requestLegacy = new _request.Request('application/json', this.$lfToken || null);
      }

      this.locations = {
        'latitude': this.$userData.latlng.split(',')[0],
        'longitude': this.$userData.latlng.split(',')[1]
      };
      this.requestParameters[process.env.VUE_APP_CUSTOMER_KEY] = this.$userInformation.customerKey || '';
      this.updateData();
    }
  }, {
    key: "mounted",
    value: function mounted() {}
  }, {
    key: "loadCoreInformation",
    value: function loadCoreInformation() {
      var _this2 = this;

      var startDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var endDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var promises = [];
      promises.push(this.requestLegacy.get('LEGACY_CORE_V3', 'routeplanning/summary', {
        dataType: 'basic',
        startTime: startDate ? startDate : (0, _moment.default)(this.$planDate).format('YYYY-MM-DD 00:00:00'),
        endTime: endDate ? endDate : (0, _moment.default)(this.$planDate).format('YYYY-MM-DD 23:59:59')
      }));

      if (this.dates.length === 0) {
        promises.push(this.request.get('AI_ROUTE_DASHBOARD', "routing/".concat(this.$planDate), this.requestParameters));
      } else {
        this.dates.forEach(function (date) {
          promises.push(_this2.request.get('AI_ROUTE', "routing/".concat(date), _this2.requestParameters));
        });
      }

      return Promise.all(promises);
    }
  }, {
    key: "updateData",
    value: function updateData() {
      var _this3 = this;

      this.loadCoreInformation().then(function (_ref) {
        var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
            summary = _ref2[0],
            data = _ref2[1];

        if (data.failed || summary.failed) {
          return Promise.reject('');
        }

        _this3.summaryData = summary.data || {};
        _this3.dashboardData = _this3.helper.get(data, 'data.count', {});
        _this3.routingData = _this3.helper.get(data, 'data.routing', {}); // this.latLng(); // not sure what is this for

        _this3.loading = false;
      }).catch(function (error) {
        _this3.dashboardData = {};
        _this3.summaryData = {};
        _this3.loading = false;
      });
    }
  }, {
    key: "latLng",
    value: function latLng() {
      if (this.routingData && this.routingData['data'].length >= 1) {
        var fRoutes = this.routingData['data'][0];
        this.selectedValues = fRoutes['truckId'] ? [Number(fRoutes['truckId'])] : []; // if (fRoutes && fRoutes['routes'] && fRoutes['routes'].length >= 1) {
        //   fRoutes['routes'].forEach( (wpData) => {
        //     if (wpData['latitude'] && wpData['longitude']) {
        //       this.selectedLatlng.push({
        //         'latitude': wpData['latitude'],
        //         'longitude': wpData['longitude']
        //       });
        //     }
        //   });
        // }
      }
    }
  }, {
    key: "updateMarker",
    value: function updateMarker() {
      var _this4 = this;

      var truckIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var index = arguments.length > 1 ? arguments[1] : undefined;
      var markMap = this.$refs.markMap;
      markMap.removeMarker();

      if (this.routingData && this.routingData['data'] && this.routingData['data'].length >= 1 && truckIds && truckIds.length >= 1 && typeof markMap !== 'undefined') {
        truckIds.forEach(function (truckId, truckIdx) {
          var routesList = _this4.routingData['data'].find(function (rData) {
            return rData && rData['routes'] && rData['routes'].length >= 1 && rData['truckId'] && rData['truckId'] === truckId;
          });

          if (routesList) {
            var locationsList = [];
            routesList['routes'].forEach(function (wpData) {
              if (wpData['latitude'] && wpData['longitude']) {
                locationsList.push({
                  'latitude': wpData['latitude'],
                  'longitude': wpData['longitude']
                });
              }
            });

            if (locationsList.length >= 1) {
              markMap.addMarker(locationsList, _this4.getVehicleColor(truckId));
            }
          }
        });
      }
    }
  }, {
    key: "getVehicleColor",
    value: function getVehicleColor(truckId) {
      var color = this.$dashboardVehicles.find(function (vehicle) {
        return vehicle['id'] === truckId;
      });
      return color && color['color'] ? color['color'] : '#387fc2';
    }
  }, {
    key: "handlePlanDateChanges",
    value: function handlePlanDateChanges() {
      this.loading = true;
      this.updateData();
    }
    /**
     * Hacked because el ui is stupid
     * */

  }, {
    key: "handleWeekChanges",
    value: function handleWeekChanges() {
      var _this5 = this;

      var weekEl = this.helper.get(this.$refs, 'week', null);

      if (!this.helper.isUndefined(weekEl)) {
        var weekNum = parseInt(weekEl.displayValue.split(' ')[1], 10);
        this.dates = this.getWeekDaysByWeekNumber(weekNum);
        this.loadCoreInformation(this.dates[0], this.dates[this.dates.length - 1]).then(function (res) {
          if (res[0].failed || res[1].failed || res[2].failed || res[3].failed || res[4].failed || res[5].failed || res[6].failed || res[7].failed) {
            return Promise.reject('');
          }

          _this5.summaryData = res[0].data || {};

          _this5.updateDashboardData(res);

          _this5.updateRoutingData(res);

          _this5.latLng();

          _this5.updateMarker();

          _this5.loading = false;
        }).catch(function (error) {
          _this5.dashboardData = {};
          _this5.summaryData = {};
          _this5.loading = false;
        });
      }
    }
  }, {
    key: "getWeekDaysByWeekNumber",
    value: function getWeekDaysByWeekNumber(weekNum) {
      var dateFormat = 'YYYY-MM-DD';
      var date = (0, _moment.default)().isoWeek(weekNum || 1).startOf('week');
      var weekLength = 7;
      var result = [];

      while (weekLength--) {
        result.push(date.format(dateFormat));
        date.add(1, 'day');
      }

      return result;
    }
  }, {
    key: "updateDashboardData",
    value: function updateDashboardData(res) {
      for (var i = 1; i <= 7; i++) {
        var tmpCountData = this.helper.get(res[i], 'data.count', {});

        if (tmpCountData) {
          if (i === 1) {
            this.dashboardData = this.helper.cloneDeep(_mainDashboard.DEFAULT_DASHBOARD_DATA);
            this.dashboardData['zone'] = tmpCountData.zone;
            this.dashboardData['location'] = tmpCountData.location;
          }

          this.dashboardData['availableOrder'] += tmpCountData.availableOrder;
          this.dashboardData['completedOrder'] += tmpCountData.completedOrder;
        }
      }
    }
  }, {
    key: "updateRoutingData",
    value: function updateRoutingData(res) {
      var _this6 = this;

      var rData = [];
      var earliestDate = null;
      var latestDate = null;

      for (var i = 1; i <= 7; i++) {
        var tmpRoutingData = this.helper.get(res[i], 'data.routing', {});

        if (i === 1) {
          this.routingData = this.helper.cloneDeep(_mainDashboard.DEFAULT_ROUTING_DATA);
        }

        if (Object.entries(tmpRoutingData).length !== 0 && tmpRoutingData.constructor === Object) {
          var _rData;

          this.routingData['orderId'] = this.helper.uniq([].concat((0, _toConsumableArray2.default)(this.routingData['orderId']), (0, _toConsumableArray2.default)(tmpRoutingData.orderId)));
          this.routingData['truckId'] = this.helper.uniq([].concat((0, _toConsumableArray2.default)(this.routingData['truckId']), (0, _toConsumableArray2.default)(tmpRoutingData.truckId)));
          this.routingData['planId'] = this.helper.uniq([].concat((0, _toConsumableArray2.default)(this.routingData['planId']), (0, _toConsumableArray2.default)(tmpRoutingData.planId)));

          (_rData = rData).push.apply(_rData, (0, _toConsumableArray2.default)(tmpRoutingData.data));
        }
      }

      rData = this.helper.groupBy(rData, 'truckId');
      this.helper.forEach(rData, function (val, key) {
        var startDate = (0, _moment.default)(val[0]['routes'][0]['startTime']).format('YYYY-MM-DD');
        var endDate = (0, _moment.default)(val[0]['routes'][val[0]['routes'].length - 1]['endTime']).format('YYYY-MM-DD');

        if (earliestDate === null) {
          earliestDate = startDate;
        }

        if (latestDate === null) {
          latestDate = endDate;
        }

        if (val.length === 1) {
          _this6.routingData['data'].push(val[0]);

          if ((0, _moment.default)(earliestDate).isAfter(startDate)) {
            earliestDate = startDate;
          }

          if ((0, _moment.default)(latestDate).isBefore(endDate)) {
            latestDate = endDate;
          }
        }

        if (val.length > 1) {
          _this6.helper.forEach(val, function (item, index) {
            if (index === 0) {
              _this6.routingData['data'].push(item);
            } else {
              var truckIndex = _this6.routingData['data'].findIndex(function (t) {
                return t.truckId === item.truckId;
              });

              if (truckIndex !== -1) {
                _this6.routingData['data'][truckIndex]['capacity1'] += item['capacity1'];
                _this6.routingData['data'][truckIndex]['capacity2'] += item['capacity2'];
                _this6.routingData['data'][truckIndex]['capacity3'] += item['capacity3'];
                _this6.routingData['data'][truckIndex]['estimatedCapacity1'] += item['estimatedCapacity1'];
                _this6.routingData['data'][truckIndex]['estimatedCapacity2'] += item['estimatedCapacity2'];
                _this6.routingData['data'][truckIndex]['estimatedCapacity3'] += item['estimatedCapacity3'];
                _this6.routingData['data'][truckIndex]['estimatedDistance'] += item['estimatedDistance'];
                _this6.routingData['data'][truckIndex]['estimatedTime'] += item['estimatedTime'];
                _this6.routingData['data'][truckIndex]['driverId'] = _this6.helper.uniq([].concat((0, _toConsumableArray2.default)(_this6.routingData['data'][truckIndex]['driverId']), (0, _toConsumableArray2.default)(item['driverId'])));
                _this6.routingData['data'][truckIndex]['projectCode'] = _this6.helper.uniq([].concat((0, _toConsumableArray2.default)(_this6.routingData['data'][truckIndex]['projectCode']), (0, _toConsumableArray2.default)(item['projectCode'])));
                _this6.routingData['data'][truckIndex]['orderId'] = [].concat((0, _toConsumableArray2.default)(_this6.routingData['data'][truckIndex]['orderId']), (0, _toConsumableArray2.default)(item['orderId']));
                _this6.routingData['data'][truckIndex]['shipmentReference'] = [].concat((0, _toConsumableArray2.default)(_this6.routingData['data'][truckIndex]['shipmentReference']), (0, _toConsumableArray2.default)(item['shipmentReference']));
                _this6.routingData['data'][truckIndex]['planId'] = [].concat((0, _toConsumableArray2.default)(_this6.routingData['data'][truckIndex]['planId']), (0, _toConsumableArray2.default)(item['planId']));
                var tmpRoutes = [].concat((0, _toConsumableArray2.default)(_this6.routingData['data'][truckIndex]['routes']), (0, _toConsumableArray2.default)(item['routes']));
                _this6.routingData['data'][truckIndex]['routes'] = tmpRoutes;
                var startDates = tmpRoutes.map(function (d) {
                  return (0, _moment.default)(d.startTime);
                });
                var endDates = tmpRoutes.map(function (d) {
                  return (0, _moment.default)(d.endTime);
                });

                var earliestStartDate = _moment.default.min(startDates);

                var latestEndDate = _moment.default.max(endDates);

                if ((0, _moment.default)(earliestDate).isAfter(earliestStartDate)) {
                  earliestDate = (0, _moment.default)(earliestStartDate).format('YYYY-MM-DD');
                }

                if ((0, _moment.default)(latestDate).isBefore(latestEndDate)) {
                  latestDate = (0, _moment.default)(latestEndDate).format('YYYY-MM-DD');
                }
              }
            }
          });
        }
      });

      var daysOfIncrement = _moment.default.duration((0, _moment.default)(latestDate).diff((0, _moment.default)(earliestDate), 'days'), 'days').asDays();

      this.ganttDOI = daysOfIncrement;
      this.ganttDate = earliestDate;
    } // duplicated

  }, {
    key: "isChina",
    get: function get() {
      return this.$userSetting['default10'];
    }
  }]);
  return LMDMainDashboardComponent;
}((0, _vuePropertyDecorator.Mixins)(_permission.PermissionMixin, _helper.HelperMixin, _logger.LoggerMixin, _loading.LoadingMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userInformation', {
  namespace: 'authentication'
})], LMDMainDashboardComponent.prototype, "$userInformation", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userSetting', {
  namespace: 'authentication'
})], LMDMainDashboardComponent.prototype, "$userSetting", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('lfToken', {
  namespace: 'authentication'
})], LMDMainDashboardComponent.prototype, "$lfToken", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userData', {
  namespace: 'authentication'
})], LMDMainDashboardComponent.prototype, "$userData", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('dashboardVehicles', {
  namespace: 'common'
})], LMDMainDashboardComponent.prototype, "$dashboardVehicles", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_DASHBOARD_VEHICLES', {
  namespace: 'common'
})], LMDMainDashboardComponent.prototype, "$setDashboardVehicles", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_PLAN_DATE', {
  namespace: 'lastMileDelivery'
})], LMDMainDashboardComponent.prototype, "$setPlanDate", void 0);
LMDMainDashboardComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDMainDashboardComponent',
  components: {
    'number-count': _numberCount.default,
    'mini-gantt-chart': _miniGanttChart.default,
    'map-world': _mapWorld.default,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-card': _elementUi.Card,
    'el-date-picker': _elementUi.DatePicker
  }
})], LMDMainDashboardComponent);
var _default = LMDMainDashboardComponent;
exports.default = _default;